import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67597dd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-navbar" }
const _hoisted_2 = { class: "session" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Sign in")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Logout")

import { useAuth0 } from '@auth0/auth0-vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { loginWithRedirect, logout, user } = useAuth0();

const onSignin = async (): Promise<void> => {
  await loginWithRedirect();
};

const onLogout = (): void => {
  logout();
};


return (_ctx: any,_cache: any) => {
  const _component_o_button = _resolveComponent("o-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(user))
        ? (_openBlock(), _createBlock(_component_o_button, {
            key: 0,
            variant: "success",
            outlined: "",
            onClick: onSignin
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(user))
        ? (_openBlock(), _createBlock(_component_o_button, {
            key: 1,
            variant: "danger",
            outlined: "",
            onClick: onLogout
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})